import type { HTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

/** Ein Tastenkürzel: ⌘K, N. Mac-Zeichen verwenden: ⌘ ⇧ ⌥ ⌃. */
export function Kbd({ className, ...rest }: HTMLAttributes<HTMLElement>) {
  return (
    <kbd
      className={cn(
        'inline-flex h-5 min-w-5 items-center justify-center rounded-xs border border-border bg-muted px-[5px] t-kbd text-muted-foreground',
        className,
      )}
      {...rest}
    />
  );
}
